import { createAction, props } from '@ngrx/store';
import { LeftPanel, MainPanel, RightPanel } from '../models/ui.model';

export const ZoomIn = createAction('[UI] Zoom in');
export const ZoomOut = createAction('[UI] Zoom out');
export const ZoomReset = createAction('[UI] Zoom reset');
export const SetLeftPanel = createAction('[UI] Set left panel tab', props<{ leftPanel: LeftPanel }>());
export const SetRightPanel = createAction('[UI] Set right panel tab', props<{ rightPanel: RightPanel }>());
export const SetMainPanel = createAction('[UI] Set main panel', props<{ mainPanel: MainPanel }>());
export const ScrollToElement = createAction('[UI] Scroll to element', props<{ selector: string }>());
export const ScrollToElementSuccess = createAction('[UI] Scroll to element success');
export const ScrollToElementFailed = createAction('[UI] Scroll to element failed');
